import { render, staticRenderFns } from "./MakeProcess.vue?vue&type=template&id=4ab22c91&scoped=true&"
import script from "./MakeProcess.vue?vue&type=script&lang=js&"
export * from "./MakeProcess.vue?vue&type=script&lang=js&"
import style0 from "./MakeProcess.vue?vue&type=style&index=0&id=4ab22c91&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab22c91",
  null
  
)

export default component.exports